import type { MeResource } from '@majuscule/contracts';
import { useQuery } from '@tanstack/react-query';
import { internalFetch } from './api';
import { queryClient } from './query-client';

/** Permission names of `/internal/me` (lot 20). */
export type Permission = MeResource['permissions'][number];

export const ME_KEY = ['me'];

const fetchMe = (): Promise<MeResource> => internalFetch<MeResource>('/internal/me');

/** The signed-in member, from the shared cache (route guards). Throws `ApiHttpError` 403 for outsiders. */
export function loadMe(): Promise<MeResource> {
  return queryClient.fetchQuery({ queryKey: ME_KEY, queryFn: fetchMe, staleTime: 60_000 });
}

/** The signed-in member: role, permissions, name. */
export function useMe() {
  return useQuery({ queryKey: ME_KEY, queryFn: fetchMe, staleTime: 60_000 });
}

/** Whether the signed-in member has a permission; false while loading. */
export function useCan(permission: Permission): boolean {
  return useMe().data?.permissions.includes(permission) ?? false;
}

export const ROLE_LABEL: Record<MeResource['role'], string> = {
  admin: 'Administrateur',
  employee: 'Commercial',
};
